let baseTempl = require('sma.admin/components/partials/conditionselect/base.mustache');
let resultsTempl = require('sma.admin/components/partials/conditionselect/results.mustache');
let searchResultsTempl = require('sma.admin/components/partials/conditionselect/searchresults.mustache');

let ajax = require('sma.common/ajax');

class ConditionSelect extends Backbone.View {
	get events() {
		return {
			'click .sma-js-search': 'dropdownClicked',
			'click .sma-js-condition-row': 'itemClicked',
			'click .sma-js-condition-back-button': 'backClicked',
			'input .sma-js-search': 'searchFilters',
		};
	}

	initialize(context) {
		this.query = [];

		this.grid = context.grid;

		this.context = context.context;

		this.award_id = context.award_id;

		this.setElement(context.$el);
	
		let content = $(baseTempl({
			strings: {
				condition: gettext('Condition')
			}
		}));

		this.$el.append(content);

		this.$conditionResults = this.grid.$el.find('.sma-js-condition-results', content);

		this.$conditionResults.toggle();

		this.throttledSearch = _.throttle(this.getSearchData, 500);
	

		// Click outside scope to close (debating if it should stay)
		var me = this;
		$(document).click(function() {
			if(me.$conditionResults.is(":visible")) {
				me.$conditionResults.toggle();
			}	
		});

		this.grid.$el.find(".sma-js-condition-select").click(function(event) {
			event.stopPropagation();
		});

	}

	searchFilters(e) {
		this.throttledSearch();
	}

	getSearchData() {
		var query = this.grid.$el.find('.sma-js-search')[0].value.toLowerCase();

		if(this.$conditionResults.is(":hidden")) {
			this.$conditionResults.toggle();
		}	

		if(query == 0) {
			this.getFindData();
			return;
		}

		ajax.get({
			url: reverse('filters-index'),
			data: {
				q: query,
				context: this.context,
				award_id: this.award_id
			},
			callback: data => {
				this.loadResults(query, data.result);
			}
		});
	}

	loadResults(query, result) {
		result.children.forEach(function(parent) {
			if(parent.hasChildren) {
				parent.children.forEach(function(child) {
					var childLabel = child.label;
					var queryIndex = childLabel.toLowerCase().indexOf(query);
					if(queryIndex != -1) {
						var insertionText = '<span class="sma-filter-selection">' + childLabel.substr(queryIndex, query.length) + '</span>';
						child.label = child.label.substr(0, queryIndex) + insertionText + child.label.substr(queryIndex + query.length);
					}
				});
			}
		});
		this.setSearchData(result);
	}

	backClicked(e) {
		var query = this.grid.$el.find('.sma-js-search').val("");
		this.query.pop();
		this.getFindData();
	}

	itemClicked(e) {
		e.preventDefault();

		let $target = $(e.currentTarget).find('a');
		
		if($target.data('has-children')) {
			this.query.push($target.data('key'));
			
			this.getFindData();
		} else {
			this.selectedCondition(e);
			this.$conditionResults.toggle();
		}	
	}

	/**
	 * What to do after selecting a condition from the condition select dropdown
	 */
	selectedCondition(e) {
		var searchBar = this.grid.$el.find('.sma-js-search');
		searchBar.val($(e.currentTarget).text().trim());
	}

	dropdownClicked(e) {
		if(this.$conditionResults.is(":hidden")) {
			this.query = [];

			this.$conditionResults.toggle();

			this.getFindData();
		}	
	}

	getFindData() {		
		this.$conditionResults.empty();

		ajax.get({
			loaderElement: this.$conditionResults,
			url: reverse('filters-index'),
			data: {
				key: this.query.join(','),
				context: this.context,
				award_id: this.award_id
			},
			callback: data => {
				this.setFindData(data.result);
			}
		})
	}

	setFindData(data) {
		this.data = data;
		this.updateFindResults();
	}

	setSearchData(data) {
		this.data = data;
		this.updateSearchResults();
	}

	updateFindResults() {
		_.each(this.data.children, function(child, i) {
			child.choices = JSON.stringify(child.choices);
		});
		this.$conditionResults.html(
			resultsTempl({
				'children': this.data.children,
				'label': this.data.label,
				'hasParent': this.data.hasParent,
				'parent': this.data.parent
			})
		);
	}

	updateSearchResults() {
		_.each(this.data.children, function(child, i) {
			_.each(child.children, function(child2, i) {
				child2.choices = JSON.stringify(child2.choices);
			});
		});
		this.$conditionResults.html(
			searchResultsTempl({'results': this.data.children})
		);
	}
}

module.exports = {
	ConditionSelect: ConditionSelect,
}
